<template>
  <div>
    <PageHeader :gradientType="gradientType" />
    <PageContent>
      <template #filterBar>
        <form @submit.prevent="setFilter">
          <h6 class="heading-small text-muted mb-4">Search</h6>
          <div class="row">
            <div class="col">
              <a-input placeholder="Search by" v-model="search">
                <a-select
                  slot="addonAfter"
                  default-value="item_code"
                  style="width: 110px"
                  v-model="searchType"
                  @change="searchTypeOnChange"
                >
                  <a-select-option value="item_code">
                    <a-tooltip title="Item Code"> Item Code </a-tooltip>
                  </a-select-option>
                  <a-select-option value="site_name">
                    <a-tooltip title="Site Name"> Site Name </a-tooltip>
                  </a-select-option>
                </a-select>
              </a-input>
            </div>
          </div>
        </form>
      </template>

      <template #pageTable>
        <PageTable
          :tableTitle="table.title"
          :apiUrl="table.apiUrl"
          :tableFields="table.fields"
          :appendedParams="table.filters"
        >
          <template #headerButtons>
            <base-button
              id="new"
              class="float-right ml-1"
              type="primary"
              v-if="selectedActions.includes('Add')"
              size="sm"
              @click="openDrawer()"
            >
              Add Entry
            </base-button>
            <base-button
              id="new"
              class="float-right ml-1"
              type="warning"
              v-if="selectedActions.includes('Bulk')"
              size="sm"
              @click="openBulkDrawer()"
            >
              Add Bulk
            </base-button>
          </template>

          <template #formDrawer>
            <a-drawer
              :width="drawer.width"
              :placement="drawer.placement"
              :visible="drawer.visible"
              @close="closeDrawer"
            >
              <ItemInventoryForm
                :viewMode="viewMode"
                :itemData="itemData"
                @closeDrawer="closeDrawer"
              />
            </a-drawer>
            <a-drawer
              :width="drawer.width"
              :placement="bulkDrawer.placement"
              :visible="bulkDrawer.visible"
              @close="closeBulkDrawer"
            >
              <BulkInventoryForm
                :viewMode="viewMode"
                :itemData="itemData"
                @closeDrawer="closeBulkDrawer"
              />
            </a-drawer>
          </template>

          <template #tableButtons="{ tableProps }">
            <button
              id="view"
              class="btn btn-success btn-sm"
              v-if="selectedActions.includes('View')"
              @click.prevent="openDrawer(tableProps.rowData)"
            >
              View
            </button>
            <button
              id="edit"
              class="btn btn-warning btn-sm"
              v-if="selectedActions.includes('Edit')"
              @click.prevent="openDrawer(tableProps.rowData)"
            >
              Edit
            </button>
            <a-popconfirm
              title="You are about to delete this record?"
              v-if="selectedActions.includes('Delete')"
              @confirm="deleteRow(tableProps.rowData)"
              okText="Delete"
              cancelText="Cancel"
            >
              <a class="btn btn-danger btn-sm text-white">Delete</a>
            </a-popconfirm>
          </template>
        </PageTable>
      </template>
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '../../components/Page/Header.vue';
import PageContent from '../../components/Page/Content.vue';
import PageTable from '../../components/Page/Table.vue';
import ItemInventoryForm from './ItemInventoryForm.vue';
import BulkInventoryForm from './BulkInventoryForm.vue';
import HTTPRequest from '../../controllers/httpRequest';
import { mapGetters } from 'vuex';
import moment from 'moment-timezone';
const ENV = process.env.VUE_APP_ENV;
const TIMEZONE = process.env.VUE_APP_TIMEZONE || 'Asia/Singapore';

export default {
  components: {
    PageHeader,
    PageContent,
    PageTable,
    ItemInventoryForm,
    BulkInventoryForm
  },
  data() {
    return {
      searchType: 'item_code',
      search: null,
      gradientType: 'gradient-purple',
      itemData: null,
      bulkDrawer: {
        visible: false,
        width: 480,
        placement: 'right'
      },
      drawer: {
        visible: false,
        width: 480,
        placement: 'right'
      },
      viewMode: false,
      table: {
        title: 'Item Inventory',
        apiUrl: '/api/v1/site_item_inventories',
        fields: [
          'actions',
          { name: 'item.code', title: 'Item Code' },
          { name: 'description', title: 'Item Description' },
          { name: 'site.name', title: 'Site Name' },
          { name: 'inventory_count', title: 'Inventory' },
          { name: 'updatedByUser.user_name', title: 'Last Update By' },
          {
            name: 'last_updated_at',
            title: 'Last Update Date',
            formatter(date) {
              if (moment(date).isValid()) {
                if (ENV === 'development') {
                  return moment(date).format('YYYY-MM-DD h:mm A');
                } else {
                  return moment
                    .tz(date, TIMEZONE)
                    .utc()
                    .format('YYYY-MM-DD h:mm A');
                }
              }
              return date;
            }
          }
        ],
        filters: {
          item_code: null,
          site_name: null
        }
      }
    };
  },
  methods: {
    searchTypeOnChange() {
      this.table.filters = {
        item_code: null,
        site_name: null
      };
      this.table.filters[this.searchType] = this.search;
    },
    openBulkDrawer(rowData = null) {
      this.viewMode = event.target.id == 'view' ? true : false;
      this.itemData = rowData;
      this.bulkDrawer.visible = true;
    },
    openDrawer(rowData = null) {
      this.viewMode = event.target.id == 'view' ? true : false;
      this.itemData = rowData;
      this.drawer.visible = true;
    },

    closeDrawer() {
      this.drawer.visible = false;
      this.itemData = null;
    },

    closeBulkDrawer() {
      this.bulkDrawer.visible = false;
      this.itemData = null;
    },

    setFilter() {
      this.$root.$emit('refreshTable');
    },

    async deleteRow(rowData) {
      const messageId = rowData.id;
      const response = await HTTPRequest.deleteRequest(
        `/api/v1/site_item_inventories/${messageId}`,
        {
          item: {
            item_id: messageId,
            membership_program_id: rowData.membership_program_id
          }
        }
      );

      if (response.message == 'Success') {
        this.$notification.success({
          message: 'Success'
        });
        this.$root.$emit('refreshTable');
      } else {
        if (response.error != undefined) {
          this.$notification.error({
            message: response.error
          });
        } else {
          this.$notification.error({
            message: 'Something went wrong. Please try again.'
          });
        }
      }
    }
  },
  created() {
    this.$store.dispatch('setCurrentModule', 'ItemInventory');
  },
  computed: {
    ...mapGetters({
      selectedActions: 'getModuleSelectedActions'
    })
  },
  watch: {
    search(val) {
      if (val == '') this.search = null;
      this.table.filters[this.searchType] = val;
    }
  }
};
</script>

<style scoped></style>
